import type { EsFile } from '@models';

export const createParticipantRequestTarget = (
  esFile: EsFile | undefined,
  esFilesBaseUrl: string
) => {
  if (!esFile?.id || !esFile.agenda) {
    throw new Error('Chybí platná reference spisu (id a agenda).');
  }

  return {
    url: `${esFilesBaseUrl}/${esFile.id}/participant`,
    esFile: {
      id: esFile.id,
      agenda: esFile.agenda,
    },
  };
};
